import {
  Configuration,
  ConfigurationParameters,
  USERApi,
  MISCApi,
  RETAILERADMINApi,
  RETAILERINVENTORYApi,
  ADVERTISERCAMPAIGNSApi,
  ADVERTISERREPORTINGApi,
  RETAILERREPORTINGApi,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import firebaseAuth from './firebaseAuth'

const BE_HOST = import.meta.env.VITE_BE_HOST ?? 'http://localhost'
const BE_PORT = import.meta.env.VITE_BE_PORT ?? '2000'

const defaultBasePath = `${BE_HOST}:${BE_PORT}`

export const coreAPIV3 = {
  misc: (configParams?: ConfigurationParameters) =>
    new MISCApi(
      new Configuration({
        basePath: defaultBasePath,
        ...configParams,
      })
    ),
  users: (configParams?: ConfigurationParameters) => {
    return new USERApi(
      new Configuration({
        accessToken: firebaseAuth.getIdToken(),
        ...configParams,
        basePath: defaultBasePath,
      })
    )
  },
  retailerInventory: (configParams?: ConfigurationParameters) =>
    new RETAILERINVENTORYApi(
      new Configuration({
        accessToken: firebaseAuth.getIdToken(),
        basePath: defaultBasePath,
        ...configParams,
      })
    ),
  advertiserCampaigns: (configParams?: ConfigurationParameters) =>
    new ADVERTISERCAMPAIGNSApi(
      new Configuration({
        accessToken: firebaseAuth.getIdToken(),
        basePath: defaultBasePath,
        ...configParams,
      })
    ),
  retailerAdmin: (configParams?: ConfigurationParameters) =>
    new RETAILERADMINApi(
      new Configuration({
        accessToken: firebaseAuth.getIdToken(),
        basePath: defaultBasePath,
        ...configParams,
      })
    ),
  advertiserReporting: (configParams?: ConfigurationParameters) =>
    new ADVERTISERREPORTINGApi(
      new Configuration({
        accessToken: firebaseAuth.getIdToken(),
        basePath: defaultBasePath,
        ...configParams,
      })
    ),
  retailerReporting: (configParams?: ConfigurationParameters) =>
    new RETAILERREPORTINGApi(
      new Configuration({
        accessToken: firebaseAuth.getIdToken(),
        basePath: defaultBasePath,
        ...configParams,
      })
    ),
}
